import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { Phone } from '../../../core/data';
import { markAsTouched } from '../../utils';
import { phoneValidator, requiredValidator } from '../../validators';

@Component({
  selector: 'app-phone-modal',
  templateUrl: './phone-modal.component.html',
})
export class PhoneModalComponent {
  active = false;
  form = new FormGroup({
    id: new FormControl(),
    number: new FormControl(null, [
      requiredValidator(),
      phoneValidator(),
    ]),
  });

  @Output() onChange = new EventEmitter<Phone>();

  open(phone?: Phone) {
    if (phone) {
      this.form.patchValue(phone);
    }

    this.active = true;
  }

  close() {
    this.form.reset();
    this.active = false;
  }

  submit() {
    if (this.form.valid) {
      this.onChange.emit(this.form.value);
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/contacts/phone-modal.component.ts